import { useEffect, useRef } from 'react';

import { useInView } from '@react-spring/web';
import useSWRInfinite from 'swr/infinite';

import type { Paginate } from '@quick/go-api-types/common';
import type { NotificationGet } from '@quick/go-api-types/notifications';

import { InlineSpinner } from '@/components/core';

export function LoadMore({
  setSize,
  data,
  isLoading,
}: ReturnType<typeof useSWRInfinite<Paginate<NotificationGet>>>) {
  const [ref, inView] = useInView();
  const isThereMore = useRef(false);
  const more = !!data?.at(-1)?.next_page_url;
  isThereMore.current = more;
  useEffect(() => {
    if (inView && !isLoading && isThereMore.current) {
      setSize((s) => s + 1);
    }
  }, [inView, isLoading, setSize]);

  useEffect(() => {
    return () => {
      setSize(1);
    };
  }, [setSize]);
  return (
    <div ref={ref} className="flex justify-center">
      {more ? (
        <InlineSpinner />
      ) : (
        <div className="h-1">
          <span className="sr-only">All notifications loaded</span>
        </div>
      )}
    </div>
  );
}
